<template>
  <div>
    <div class="logo-search">
      <h1 class="logo">
        <a class="logoImg" href="http://zhongxue.xdf.cn/xinban/"></a>
      </h1>
      <city-mask :hotKeyWords="hotKeyWords"></city-mask>
      <a class="quick_teaching" href="http://souke.xdf.cn/">快捷搜课</a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { hotKeyWords } from 'js/middleschool/hotkeywords.js'
import CityMask from '@/common-components/Citymask'
export default {
  name: 'Logotitle',
  props: ['data'],
  components: {
    CityMask
  },
  data () {
    return {
      hotKeyWordsList: [],
      phoneNum: '',
      searchVal: '',
      hotSearchKeyword: {},
      hotKeyWords
    }
  },
  computed: {
    cityId () {
      return this.soukecityId
    },
    ...mapState(['soukecityId', 'cityName'])
  },
  methods: {
    soukechId () {
      window.open(`http://souke1.xdf.cn/Search.aspx?cid=${this.cityId}&kw=${this.searchVal}`)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/mixins.styl'
.logo-search
  width: $defaultwidth
  height: 112px
  margin: $defaultmargin
  font-size: 14px
  vertically()
  .logo
    vertically()
    float :left
    .logoImg
      height: 58px
      width: 202px
      background: url(http://file.xdf.cn/neworiental/images/newlogo.png) no-repeat 4px -156px
      text-align: center
      vertically()
      img
        margin-top:20px
  div
    flex: 1
  .quick_teaching
    color: $themeColor
    display: block
    width: 98px
    height: 33px
    line-height: 33px
    margin-left: 10px
    border: 1px solid #CBE9E9
    background: #E2F8F7
    float: right
    font: 14px/34px '微软雅黑'
    cursor: pointer
    text-align: center
    margin-top: 9px
.logo-search:after
  content: ' '
  display: block
  clear: both
</style>



// WEBPACK FOOTER //
// src/pages/middleschool/components/Logosearch.vue